import React, { useEffect, useState } from "react";
import axios from "axios";

const MarqueeSettings = () => {
  const [marquee, setMarquee] = useState({
    text: "",
    is_enabled: true,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    fetchMarquee();
  }, []);

  const fetchMarquee = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL_API}/marquee`);
      setMarquee(response.data);
    } catch (err) {
      console.error("Failed to fetch marquee:", err);
      setError("Failed to load marquee settings.");
    } finally {
      setLoading(false);
    }
  };

  const handleTextChange = (e) => {
    setMarquee({ ...marquee, text: e.target.value });
  };

  const handleToggleEnabled = () => {
    setMarquee({ ...marquee, is_enabled: !marquee.is_enabled });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setError(null);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL_API}/marquee/update`,
        marquee,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      setSuccessMessage("Marquee updated successfully!");
      fetchMarquee();
    } catch (err) {
      console.error("Failed to update marquee:", err);
      setError("Failed to update marquee settings.");
    }
  };

  if (loading) {
    return (
      <div className="ml-0 lg:ml-[230px] mt-4 bg-[#F5F5F4] pl-4 md:pl-0 min-h-screen">
        <div className="text-center py-10">Loading...</div>
      </div>
    );
  }

  return (
    <div className="ml-0 lg:ml-[230px] mt-4 bg-[#F5F5F4] pl-4 md:pl-0 min-h-screen">
      <div className="flex items-center justify-between gap-1 rounded-t-lg px-5">
        <div>
          <h2 className="text-xl font-medium text-[#292524]">Marquee Settings</h2>
          <p className="mt-2">Web / Marquee</p>
        </div>
      </div>

      <section className="mt-4 px-5">
        <div className="bg-white rounded-lg shadow-sm p-6 max-w-3xl">
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Success Message */}
            {successMessage && (
              <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded">
                {successMessage}
              </div>
            )}

            {/* Error Message */}
            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
                {error}
              </div>
            )}

            {/* Marquee Text Input */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Marquee Text
              </label>
              <textarea
                value={marquee.text}
                onChange={handleTextChange}
                rows={3}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter the text to display in the marquee..."
                required
              />
              <p className="text-xs text-gray-500 mt-1">
                This text will scroll across the top of the homepage.
              </p>
            </div>

            {/* Enable/Disable Toggle */}
            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-md">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Display Marquee
                </label>
                <p className="text-xs text-gray-500 mt-1">
                  Toggle to show or hide the marquee on the website.
                </p>
              </div>
              <button
                type="button"
                onClick={handleToggleEnabled}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${marquee.is_enabled ? "bg-[#228BE6]" : "bg-gray-300"
                  }`}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${marquee.is_enabled ? "translate-x-6" : "translate-x-1"
                    }`}
                />
              </button>
            </div>

            {/* Preview */}
            <div className="border-t pt-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Preview
              </label>
              <div className="overflow-hidden bg-gradient-to-r from-[#1c0d36] via-[#4a1f7f] to-[#7a3fff] rounded-lg p-3">
                <div className="text-white text-center font-semibold uppercase">
                  {marquee.text || "Enter text above to see preview..."}
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="flex gap-2">
              <button
                type="submit"
                className="bg-[#228BE6] text-white px-6 py-2 rounded-md hover:bg-[#1c7ed6] transition duration-200"
              >
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
};

export default MarqueeSettings;
